module.exports = __webpack_public_path__ + "static/media/logo-grey.d649b995.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/logo-grey.svg
// module id = 285
// module chunks = 0